import type { EventTopic } from "@otto-ec/global-resources/nexus";
import { components } from "../../../common/component.js";
import type * as api from "./SheetV1.api";
import type { CloseTypes } from "./events";

declare global {
  interface OttoComponentApi {
    /**
 *
 */
    sheetV1: {
      open: typeof api.open;
      close: typeof api.close;
      back: typeof api.back;
      getOpenSheet: typeof api.getOpenSheet;
      getContent: typeof api.getContent;
      getHeader: typeof api.getHeader;
      getActions: typeof api.getActions;
      /*     */
      openEvent: EventTopic<{ instance: HTMLOcSheetV1Element }>;
      closeEvent: EventTopic<{ instance: HTMLOcSheetV1Element; closeType: CloseTypes }>;
      switchEvent: EventTopic<{ instance: HTMLOcSheetV1Element }>;
      contentLoadedEvent: EventTopic<{ instance: HTMLOcSheetV1Element }>;
      contentLoadingErrorEvent: EventTopic<{ instance: HTMLOcSheetV1Element; error: unknown }>;
    };
  }
}

/*                                           */
const { sheetV1 } = components;
/*                                                                              */
export { sheetV1 as sheet };
/*                       */
export const { open, close, back, getOpenSheet, getHeader, getContent, getActions } = sheetV1;
